export default __webpack_public_path__ + "static/home-hero-cb8fbf9b67cb01c575611d55aef7c3e7.jpg";